import React from "react";
import {
    ButtonHeader,
    DeleteButton, ExchangeContainer, FavDelExchangeIcon,
    FavoriteButton,
    FavoritesContainer, FavoritesDeletedRow,
    MainContainer, PriceContainer
} from "./Favorites.styled";
import {ReactComponent as Fav} from "../../assets/icons/fav.svg";
import {ReactComponent as Restore} from "../../assets/icons/restore.svg";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {IFavoriteDeleteItem, ITOHistory} from "../../types";
import {DELETED_MARKETS_KEY, FAVORITES_MARKETS_KEY} from "../../constants";
import {setDeleted, setFavorites} from "../../redux/actions";
import {useAppDispatch} from "../../redux/store";
import {AppText, imageLinkToEx} from "../../utils";

export const Favorites: React.FC = () => {
    const dispatch = useAppDispatch()
    const [isSelectedOpen, setIsSelectedOpen] = React.useState(true);

    const favoritesMarkets = useSelector(selectors.selectFavorites)
    const deletedMarkets = useSelector(selectors.selectDeleted)
    const lang = useSelector(selectors.selectLang)
    // const marketIsFavorite = (market: string): boolean => Boolean(favoritesMarkets.find((item) => item.market === market))
    // const marketIsDeleted = (market: string): boolean => Boolean(deletedMarkets.find((item) => item.market === market))

    // const addToFavorite = (item: IFavoriteDeleteItem): void => {
    //     localStorage.setItem(FAVORITES_MARKETS_KEY, JSON.stringify([...favoritesMarkets, {lastProfit: item.lastProfit, market: item.market}]))
    //     dispatch(setFavorites([...favoritesMarkets, {lastProfit: item.pure_profit, market: item.market}]))
    // }
    const removeFromFavorite = (item: IFavoriteDeleteItem): void => {
        localStorage.setItem(FAVORITES_MARKETS_KEY, JSON.stringify([...favoritesMarkets.filter((fav) => fav.market !== item.market)]))
        dispatch(setFavorites([...favoritesMarkets.filter((fav) => fav.market !== item.market)]))
    }
    // const addToDeleted = (item: IFavoriteDeleteItem): void => {
    //     localStorage.setItem(DELETED_MARKETS_KEY, JSON.stringify([...deletedMarkets, {lastProfit: item.pure_profit, market: item.market}]))
    //     dispatch(setDeleted([...deletedMarkets, {lastProfit: item.pure_profit, market: item.market}]))
    // }
    const removeFromDeleted = (item: IFavoriteDeleteItem): void => {
        localStorage.setItem(DELETED_MARKETS_KEY, JSON.stringify([...deletedMarkets.filter((del) => del.market !== item.market)]))
        dispatch(setDeleted([...deletedMarkets.filter((del) => del.market !== item.market)]))
    }
    // const toggleFavorite = (includes: boolean, item: IFavoriteDeleteItem)=> {
    //     if (includes) {
    //         removeFromFavorite(item)
    //     } else {
    //         addToFavorite(item)
    //     }
    // }
    // const toggleDeleted = (includes: boolean, item: IFavoriteDeleteItem)=> {
    //     if (includes) {
    //         removeFromDeleted(item)
    //     } else {
    //         addToDeleted(item)
    //     }
    // }
    return (
        <FavoritesContainer>
            <ButtonHeader>
                <FavoriteButton
                    isOpen={isSelectedOpen}
                    onClick={() => {
                        setIsSelectedOpen(true)
                    }}
                >{AppText[lang].fav.a}({favoritesMarkets.length})</FavoriteButton>
                <DeleteButton
                    isOpen={!isSelectedOpen}
                    onClick={() => {
                        setIsSelectedOpen(false)
                    }}
                >{AppText[lang].fav.b}({deletedMarkets.length})</DeleteButton>
            </ButtonHeader>
            <MainContainer>
                {isSelectedOpen && favoritesMarkets.map((item, index) => (
                  <FavoritesDeletedRow key={item.market}>
                      <PriceContainer isFav={isSelectedOpen}>
                          <div onClick={() => removeFromFavorite(item)}>
                              <Fav/>
                          </div>
                          <span>{item.market}</span>
                      </PriceContainer>
                      <ExchangeContainer>
                          <FavDelExchangeIcon $src={imageLinkToEx(item.first_ex)}/>
                          <FavDelExchangeIcon $src={imageLinkToEx(item.second_ex)}/>
                      </ExchangeContainer>
                  </FavoritesDeletedRow>
                ))}
                {!isSelectedOpen && deletedMarkets.map((item, index) => (
                  <FavoritesDeletedRow key={item.market}>
                      <PriceContainer isFav={isSelectedOpen}>
                          <div onClick={() => removeFromDeleted(item)}>
                              <Restore/>
                          </div>
                          <span>{item.market}</span>
                      </PriceContainer>
                      <ExchangeContainer>
                          <FavDelExchangeIcon $src={imageLinkToEx(item.first_ex)}/>
                          <FavDelExchangeIcon $src={imageLinkToEx(item.second_ex)}/>
                      </ExchangeContainer>
                  </FavoritesDeletedRow>
                ))}
            </MainContainer>
        </FavoritesContainer>
    )
}